import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["size", "intent", "target"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { useMemo, useState, useEffect, forwardRef } from 'react';
import FocusLock from 'react-focus-lock';
import { useStyles, StyleSheet, StylesProvider, useToken, padding, border, text, margin, mq } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { GhostIconButton } from '@rexlabs/button';
import Icons from '@rexlabs/icons';
import { ScrollShadow } from '@rexlabs/scroll-shadow';
import { useResizeObserver } from '@rexlabs/react-hooks';
import { Portal } from '@rexlabs/portal';
import { useMediaQuery } from '@rexlabs/breakpoints';
import LoadingState from '../loading-state';
var CrossLarge = Icons.CrossLarge;
var defaultStyles = StyleSheet({
  dialog: {
    position: 'relative',
    overflow: 'hidden',
    height: 'auto',
    maxHeight: '100vh',
    maxWidth: '100vw',
    color: function color(_ref) {
      var token = _ref.token;
      return token('dialog.color');
    },
    zIndex: function zIndex(_ref2) {
      var token = _ref2.token;
      return token('zIndex.base', 0);
    },
    boxShadow: function boxShadow(_ref3) {
      var token = _ref3.token;
      return token('dialog.boxShadow', token('shadow.medium'));
    },
    backgroundColor: function backgroundColor(_ref4) {
      var token = _ref4.token;
      return token('dialog.background.color', token('color.container.static.default'));
    }
  },
  dialogSmall: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'l'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref5) {
        var token = _ref5.token;
        return "calc(100vh - ".concat(token('spacing.l'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      height: 'auto',
      maxWidth: '68.8rem'
    }, margin.styles({
      all: 'xxxl'
    })), border.styles({
      all: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref6) {
        var token = _ref6.token;
        return "calc(100vw - (".concat(token('spacing.xxxl'), " * 2))");
      },
      maxHeight: function maxHeight(_ref7) {
        var token = _ref7.token;
        return "calc(100vh - (".concat(token('spacing.xxxl'), " * 2))");
      }
    })
  }])),
  dialogMedium: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'l'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref8) {
        var token = _ref8.token;
        return "calc(100vh - ".concat(token('spacing.l'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      height: 'auto',
      maxWidth: '94.4rem'
    }, margin.styles({
      all: 'xxxl'
    })), border.styles({
      all: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref9) {
        var token = _ref9.token;
        return "calc(100vw - (".concat(token('spacing.xxxl'), " * 2))");
      },
      maxHeight: function maxHeight(_ref10) {
        var token = _ref10.token;
        return "calc(100vh - (".concat(token('spacing.xxxl'), " * 2))");
      }
    })
  }])),
  dialogLarge: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'l'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref11) {
        var token = _ref11.token;
        return "calc(100vh - ".concat(token('spacing.l'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'xxxl'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref12) {
        var token = _ref12.token;
        return "calc(100vh - ".concat(token('spacing.xxxl'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      height: 'auto',
      maxWidth: '120rem'
    }, margin.styles({
      all: 'xxxl'
    })), border.styles({
      all: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref13) {
        var token = _ref13.token;
        return "calc(100vw - (".concat(token('spacing.xxxl'), " * 2))");
      },
      maxHeight: function maxHeight(_ref14) {
        var token = _ref14.token;
        return "calc(100vh - (".concat(token('spacing.xxxl'), " * 2))");
      }
    })
  }])),
  dialogExtraLarge: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'l'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref15) {
        var token = _ref15.token;
        return "calc(100vh - ".concat(token('spacing.l'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'xxxl'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref16) {
        var token = _ref16.token;
        return "calc(100vh - ".concat(token('spacing.xxxl'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      height: 'auto',
      maxWidth: '144rem'
    }, margin.styles({
      all: 'xxxl'
    })), border.styles({
      all: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref17) {
        var token = _ref17.token;
        return "calc(100vw - (".concat(token('spacing.xxxl'), " * 2))");
      },
      maxHeight: function maxHeight(_ref18) {
        var token = _ref18.token;
        return "calc(100vh - (".concat(token('spacing.xxxl'), " * 2))");
      }
    })
  }])),
  dialogFullscreen: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'l'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref19) {
        var token = _ref19.token;
        return "calc(100vh - ".concat(token('spacing.l'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      width: '100vw'
    }, margin.styles({
      top: 'xxxl'
    })), border.styles({
      top: {
        radius: 'l'
      }
    })), {}, {
      height: function height(_ref20) {
        var token = _ref20.token;
        return "calc(100vh - ".concat(token('spacing.xxxl'), ")");
      }
    })
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: _objectSpread(_objectSpread({
      height: '100vh',
      width: '100vw'
    }, margin.styles({
      all: 'none'
    })), border.styles({
      all: {
        radius: 'none'
      }
    }))
  }])),
  dialogAlert: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      height: 'auto'
    }, margin.styles({
      all: 'l'
    })), border.styles({
      all: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref21) {
        var token = _ref21.token;
        return "calc(100vw - (".concat(token('spacing.l'), " * 2))");
      },
      maxHeight: function maxHeight(_ref22) {
        var token = _ref22.token;
        return "calc(100vh - (".concat(token('spacing.xxxl'), " * 2))");
      }
    })
  }, {
    queries: {
      minWidth: 's'
    },
    styles: _objectSpread(_objectSpread(_objectSpread({
      height: 'auto'
    }, margin.styles({
      all: 'xxxl'
    })), border.styles({
      all: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref23) {
        var token = _ref23.token;
        return "calc(100vw - (".concat(token('spacing.xxxl'), " * 2))");
      },
      maxHeight: function maxHeight(_ref24) {
        var token = _ref24.token;
        return "calc(100vh - (".concat(token('spacing.xxxl'), " * 2))");
      }
    })
  }])),
  inner: {
    width: '100%',
    overflow: 'hidden'
  },
  innerFullscreen: {
    maxWidth: '144rem'
  },
  titleBar: _objectSpread({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
    alignItems: 'center'
  }, mq.styles.combine([{
    queries: {
      maxWidth: 'm'
    },
    styles: _objectSpread({}, padding.styles({
      target: 'dialog.title',
      y: 'xxl',
      left: 'xl',
      right: 'm'
    }))
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: _objectSpread({}, padding.styles({
      target: 'dialog.title',
      y: 'xxl',
      left: 'xxxl',
      right: 'xxl'
    }))
  }])),
  titleBarAlert: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 'm'
    },
    styles: _objectSpread({}, padding.styles({
      target: 'dialog.title',
      all: 'xl'
    }))
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: _objectSpread({}, padding.styles({
      target: 'dialog.title',
      all: 'xl'
    }))
  }])),
  titleIcon: {
    marginRight: function marginRight(_ref25) {
      var token = _ref25.token;
      return token('spacing.s');
    }
  },
  title: _objectSpread(_objectSpread({
    display: 'flex',
    flex: 1,
    zIndex: 2
  }, text.styles({
    target: 'dialog.title',
    fallback: 'heading.2'
  })), margin.styles({
    target: 'dialog.title',
    right: 'm'
  })),
  titleAlert: _objectSpread({}, text.styles({
    fallback: 'heading.3'
  })),
  content: _objectSpread(_objectSpread({
    maxWidth: '100%',
    zIndex: 2
  }, text.styles({
    target: 'dialog.content',
    fallback: 'normal.default'
  })), mq.styles.combine([{
    queries: {
      maxWidth: 'm'
    },
    styles: _objectSpread(_objectSpread({}, padding.styles({
      target: 'dialog.content',
      x: 'xl',
      bottom: 'xl'
    })), {}, {
      '& [data-stickyfooter]': _objectSpread(_objectSpread({
        bottom: 0
      }, margin.styles({
        target: 'dialog.content.stickyFooter',
        x: function x(_ref26) {
          var token = _ref26.token;
          return "-".concat(token('spacing.xl'));
        },
        top: 'xl',
        bottom: function bottom(_ref27) {
          var token = _ref27.token;
          return "-".concat(token('spacing.xl'));
        }
      })), padding.styles({
        target: 'dialog.content.stickyFooter',
        x: 'xl',
        y: 'xl'
      }))
    })
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: _objectSpread(_objectSpread({}, padding.styles({
      target: 'dialog.content',
      x: 'xxxl',
      bottom: 'xl'
    })), {}, {
      '& [data-stickyfooter]': _objectSpread(_objectSpread({
        bottom: 0
      }, margin.styles({
        target: 'dialog.content.stickyFooter',
        x: function x(_ref28) {
          var token = _ref28.token;
          return "-".concat(token('spacing.xxxl'));
        },
        top: 'xl',
        bottom: function bottom(_ref29) {
          var token = _ref29.token;
          return "-".concat(token('spacing.xl'));
        }
      })), padding.styles({
        target: 'dialog.content.stickyFooter',
        x: 'xxxl',
        y: 'xl'
      }))
    })
  }]))
});
var overrides = {
  button: {
    group: {
      margin: {
        top: function top(_ref30) {
          var token = _ref30.token;
          return token('dialog.padding', token('spacing.xl', '2.4rem'));
        }
      }
    }
  }
};
var dialogSize = {
  s: 'dialogSmall',
  m: 'dialogMedium',
  l: 'dialogLarge',
  xl: 'dialogExtraLarge',
  fullscreen: 'dialogFullscreen'
};
var innerSize = {
  fullscreen: 'innerFullscreen'
};
var dialogIntent = {
  alert: 'dialogAlert'
};
var titleBarIntent = {
  alert: 'titleBarAlert'
};
var titleIntent = {
  alert: 'titleAlert'
};
var displayName = 'Dialog';
export var DialogInner = /*#__PURE__*/forwardRef(function DialogInner(_ref31, ref) {
  var _document$querySelect;

  var style = _ref31.style,
      className = _ref31.className,
      title = _ref31.title,
      _ref31$size = _ref31.size,
      size = _ref31$size === void 0 ? 'm' : _ref31$size,
      _ref31$intent = _ref31.intent,
      intent = _ref31$intent === void 0 ? 'modal' : _ref31$intent,
      children = _ref31.children,
      onClose = _ref31.onClose,
      isLoading = _ref31.isLoading,
      _ref31$loadingMessage = _ref31.loadingMessage,
      loadingMessage = _ref31$loadingMessage === void 0 ? 'Loading data...' : _ref31$loadingMessage,
      TitleIcon = _ref31.TitleIcon,
      _ref31$Loading = _ref31.Loading,
      Loading = _ref31$Loading === void 0 ? LoadingState : _ref31$Loading;
  var s = useStyles(defaultStyles, displayName);
  var token = useToken();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      headerOffset = _useState2[0],
      setHeaderOffset = _useState2[1];

  var iconSize = token('dialog.title.icon.svg.size', 'l');
  var headerRef = useResizeObserver(function (_ref32) {
    var _ref33, _borderBoxSize$0$bloc, _borderBoxSize$;

    var target = _ref32.target,
        borderBoxSize = _ref32.borderBoxSize;
    return setHeaderOffset((_ref33 = (_borderBoxSize$0$bloc = borderBoxSize === null || borderBoxSize === void 0 ? void 0 : (_borderBoxSize$ = borderBoxSize[0]) === null || _borderBoxSize$ === void 0 ? void 0 : _borderBoxSize$.blockSize) !== null && _borderBoxSize$0$bloc !== void 0 ? _borderBoxSize$0$bloc : target === null || target === void 0 ? void 0 : target.offsetHeight) !== null && _ref33 !== void 0 ? _ref33 : 0);
  }, []);
  var footerOffset = (_document$querySelect = document.querySelector('[data-stickyfooter]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight; // Close the dialog on `esc` key

  useEffect(function () {
    function handleKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
      }
    }

    window.document.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);
  return /*#__PURE__*/React.createElement(FocusLock, {
    returnFocus: true
  }, /*#__PURE__*/React.createElement(Box, _extends({}, s.with('dialog', dialogSize[size], dialogIntent[intent])({
    style: style,
    className: className
  }), {
    ref: ref,
    role: "dialog",
    alignItems: "center",
    flexDirection: "column"
  }), /*#__PURE__*/React.createElement(Box, _extends({}, s('inner', innerSize[size]), {
    flex: 1,
    flexDirection: "column"
  }), title && /*#__PURE__*/React.createElement("header", _extends({}, s('titleBar', titleBarIntent[intent]), {
    ref: headerRef
  }), TitleIcon && /*#__PURE__*/React.createElement(TitleIcon, _extends({
    size: iconSize
  }, s('titleIcon'))), /*#__PURE__*/React.createElement("h2", s('title', titleIntent[intent]), title), onClose && /*#__PURE__*/React.createElement(GhostIconButton, {
    Icon: CrossLarge,
    onClick: onClose
  })), /*#__PURE__*/React.createElement(ScrollShadow, {
    flexDirection: "column",
    offsets: {
      top: headerOffset,
      bottom: footerOffset
    }
  }, /*#__PURE__*/React.createElement(Box, _extends({}, s('content'), {
    flex: 1,
    flexDirection: "column"
  }), /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: overrides
  }, isLoading ? /*#__PURE__*/React.createElement(Loading, null, loadingMessage) : children))))));
});
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 */

export var Dialog = /*#__PURE__*/forwardRef(function Dialog(_ref34, ref) {
  var _context;

  var size = _ref34.size,
      intent = _ref34.intent,
      _ref34$target = _ref34.target,
      target = _ref34$target === void 0 ? 'dialogs' : _ref34$target,
      props = _objectWithoutProperties(_ref34, _excluded);

  var matchesSmall = useMediaQuery({
    maxWidth: 's'
  });
  var matchesMedium = useMediaQuery({
    minWidth: 's',
    maxWidth: 'm'
  });
  var animationTarget = useMemo(function () {
    if (intent !== 'alert' && (matchesSmall || matchesMedium && (size === 'l' || size === 'xl'))) {
      return 'slide';
    }

    return 'fade';
  }, [size, intent, matchesSmall, matchesMedium]);
  return (
    /*#__PURE__*/
    // We have to portal the dialog inner so that we can measure DOM
    // using our resize observers as the portalled component mounts
    React.createElement(Portal, {
      target: _concatInstanceProperty(_context = "".concat(target, "-")).call(_context, animationTarget)
    }, /*#__PURE__*/React.createElement(DialogInner, _extends({}, props, {
      ref: ref,
      size: size,
      intent: intent
    })))
  );
});